import favicon from "../assets/favicon-v2.ico";
import Session from '../models/Session';
import User from '../models/User';
import CommandsProvider from './CommandsProvider.js';

String.prototype.insert = function(index, string) {
    if (index > 0)
        return this.substring(0, index) + string + this.substring(index);
    return string + this;
};

const Helper = {
    activeNotifications: {}, // Registro de notificações ativas
    debounceTimer: null, // Temporizador de debounce
    /* Registrar funções Helpers de acordo com a necessidade */
    async TestIfIsOnline(testUrl = `${process.env.REACT_APP_API_URL}/localtoweb/ping`) {
        if (!navigator.onLine) return false;
        try {
            const response = await fetch(testUrl, { method: "GET", cache: "no-cache" });
            return response.ok;
        } catch (e) {
            return false;
        }
    },
    IsValidEmail(email) {
        if (typeof email !== "string") return false;
        // Regex simples e eficiente para e-mail
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim());
    },
    TryParseJson (jsonStr) 
    {
        try
        {
            let validJsonPattern = /[{}[\]":,.\-0-9a-zA-Z\s]/g;
            let jsonObj = JSON.parse(jsonStr.match(validJsonPattern).join(''));

            if (jsonObj && typeof jsonObj === "object")
            {
                return jsonObj;
            }
        }
        catch (e)
        {
            console.log("🚀 ~ TryParseJson ~ e:", e)
            return false;
        }
    },
    Beep(type = "beep") 
    {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        
        oscillator.type = type; // Pode ser 'sine', 'square', 'sawtooth', 'triangle'
        oscillator.frequency.setValueAtTime(1000, audioContext.currentTime); // Frequência em Hertz (A4)
        
        oscillator.connect(audioContext.destination);
        oscillator.start();
        oscillator.stop(audioContext.currentTime + 0.1); // Para o oscilador após um tempo (exemplo: 500ms)
    },
    Notification(message = "", tag = null, debounceTime = 2000)
    {
        const triggerNotification = () => {
            switch (Notification.permission)
            {
                case "granted":
                    if (!this.activeNotifications[tag]) 
                    {
                        const notification = new Notification("Guardião 2.0", {
                            body: message,
                            icon: favicon,
                            //tag: tag
                        });
                    
                        this.activeNotifications[tag] = notification;
                    
                        // Remover a notificação do registro quando ela for fechada
                        setTimeout(() => { delete this.activeNotifications[tag] } ,60000);
                    }
                    break;
            default:
                Notification.requestPermission().then(permission => {
                    this.Notification(message, tag, debounceTime);
                });
                break;
            }
        };

        // Implementar debounce
        if (this.debounceTimer) 
        {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            triggerNotification();
        }, debounceTime);
    },
    GenerateGUID()
    {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function(c) {
            var uuid = Math.random() * 16 | 0, v = c == 'x' ? uuid : (uuid & 0x3 | 0x8);
            return uuid.toString(16);
        });
    },
    HtmlStringToElement(htmlString) {
        const parser = new DOMParser();
        return parser.parseFromString(htmlString, 'text/html');
    },
    AddFragment(texto, padrao, fragmento) {
        // Cria uma expressão regular com o padrão fornecido
        const regex = new RegExp(padrao, 'g');
      
        // Usa o método replace para adicionar o fragmento onde o padrão corresponder
        return texto.replace(regex, (match) => `${match}${fragmento}`);
    },
    ConvertSessionToUser(session) {
        if (!session) return null;
        return User.fromSession(session);
    },

    ConvertUserToSession(user) {
        if (!user) return null;
        // Se não for instância de User, converte
        if (!(user instanceof User)) {
            user = Object.assign(new User(), user);
        }
        return user.toSession();
    },

    GetUserFromSession() {
        const userData = CommandsProvider.getSession();
        if (!userData) return null;

        const user = new User();
        Object.assign(user, userData);
        return user;
    },

    GetUserFromLocalStorage() {
        const userJson = localStorage.getItem('user');
        if (!userJson) return new User();
        const userData = this.TryParseJson(userJson);
        if (!userData) return new User();
        const user = Object.assign(new User(), userData);
        return user;
    },

    SetUserToLocalStorage(user) {
        if (!user) {
            localStorage.removeItem('user');
            return;
        }
        localStorage.setItem('user', JSON.stringify(user));
    },

    TerminalFire: {
        decriptKey(key) {
            if (!key || typeof key !== "string") return "erro";
            const keyElements = key.split("-");
            if (keyElements.length < 7) return "erro";
            if (keyElements[0].toUpperCase() !== "5446") return "erro";

            // Série em HEX
            const serialHex = keyElements[1];
            if (serialHex.length !== 8) return "erro";
            const S4 = serialHex.substring(0, 2);
            const S3 = serialHex.substring(4, 6);
            const S2 = serialHex.substring(2, 4);
            const S1 = serialHex.substring(6, 8);

            // Verificadores
            const V1 = parseInt(keyElements[2], 16);
            const V2 = parseInt(keyElements[3], 16);

            // Quantidade (Q1Q2)
            const Q1 = keyElements[4].substring(0, 2);
            const Q2 = keyElements[4].substring(2, 4);

            // Verificador de quantidade
            const V3 = parseInt(keyElements[5], 16);

            // Checagem dos verificadores
            let v1_calc = parseInt(S1, 16) + parseInt(S4, 16) + 0x54;
            while (v1_calc > 0xFF) v1_calc -= 0xFF;
            if (V1 !== v1_calc) return "erro";

            let v2_calc = parseInt(S2, 16) + parseInt(S3, 16) + 0x46;
            while (v2_calc > 0xFF) v2_calc -= 0xFF;
            if (V2 !== v2_calc) return "erro";

            // Quantidade em ASCII
            const qtdStr = String.fromCharCode(parseInt(Q1, 16)) + String.fromCharCode(parseInt(Q2, 16));
            const qtd = parseInt(qtdStr, 10);
            if (isNaN(qtd) || qtd < 1) return "erro";

            let v3_calc = qtd + 0x47 + parseInt(S4, 16);
            while (v3_calc > 0xFF) v3_calc -= 0xFF;
            if (V3 !== v3_calc) return "erro";

            // Série final em decimal
            const serie = [
                S1, S2, S3, S4
            ].map(x => parseInt(x, 16).toString().padStart(3, "0")).join("");

            return `TF-${serie}-${qtd}-TF`;
        },

        generateKeyForSerial(serial, quantidade = 1) {
            // serial: "000000031197" (12 dígitos)
            if (!serial || serial.length !== 12) return null;
            const S1 = parseInt(serial.substring(0,3), 10).toString(16).padStart(2, "0");
            const S2 = parseInt(serial.substring(3,6), 10).toString(16).padStart(2, "0");
            const S3 = parseInt(serial.substring(6,9), 10).toString(16).padStart(2, "0");
            const S4 = parseInt(serial.substring(9,12), 10).toString(16).padStart(2, "0");

            // V1 = S1 + S4 + 0x54
            let v1 = parseInt(S1, 16) + parseInt(S4, 16) + 0x54;
            while (v1 > 0xFF) v1 -= 0xFF;

            // V2 = S2 + S3 + 0x46
            let v2 = parseInt(S2, 16) + parseInt(S3, 16) + 0x46;
            while (v2 > 0xFF) v2 -= 0xFF;

            // Quantidade em ASCII
            const qtdStr = quantidade.toString().padStart(2, "0");
            const Q1 = qtdStr[0].charCodeAt(0).toString(16).padStart(2, "0");
            const Q2 = qtdStr[1].charCodeAt(0).toString(16).padStart(2, "0");

            // V3 = quantidade + 0x47 + S4
            let v3 = parseInt(quantidade, 10) + 0x47 + parseInt(S4, 16);
            while (v3 > 0xFF) v3 -= 0xFF;

            // Monta chave
            return `5446-${S4}${S2}${S3}${S1}-${v1.toString(16).padStart(2, "0")}-${v2.toString(16).padStart(2, "0")}-${Q1}${Q2}-${v3.toString(16).padStart(2, "0")}-TF`.toUpperCase();
        }
    },

    LicenseGenerator: {
        lastRandom: -1,
        LICENSE_TYPES: {
            FREE: 'f',
            DESKTOP: 'd', 
            WEB: 'w',
            TECHNICIAN: 't'
        },
        generateTechnicianLicense(hdd, quantity = 1) {
            if (!hdd || hdd.length !== 8) {
                console.error('HDD serial deve ter 8 caracteres');
                return null;
            }

            const model = "DF0023-TEC-1A";
            const licenseType = ["7", "4"];
            const serial = this.getHDDSerial(hdd);
            const random = this.getRandom();
            const expires = this.getExpiresDate(quantity, model);
            const checker1 = this.getChecker(serial[2], expires[0]);
            const checker2 = this.getChecker(serial[3], expires[1]);
            const serialBytes = serial.map(part => parseInt(part, 10).toString(16).padStart(2, '0').toUpperCase());

            const partOne = licenseType[0] + random;
            const partTwo = (serialBytes[2] + serialBytes[0] + serialBytes[3] + serialBytes[1]).insert(random, licenseType[1]);
            const partThree = expires[1] + expires[3] + expires[2] + expires[0];

            return `${partOne}-${partTwo}-${checker1}-${partThree}-${checker2}-DF`;
        },

        generateFreeLicense(serialNumber, quantity = 1) {
            if (!serialNumber || serialNumber.length > 12) {
                console.error('Serial do painel deve ter até 12 caracteres');
                return null;
            }

            const model = "DF0023-FL";
            const licenseType = ["6", "6"];
            const serial = this.getPanelSerial(serialNumber);
            const random = this.getRandom();
            const expires = this.getExpiresDate(quantity, model);
            const checker1 = this.getChecker(serial[2], expires[0]);
            const checker2 = this.getChecker(serial[3], expires[1]);

            const serialBytes = serial.map(part => parseInt(part, 10).toString(16).padStart(2, '0').toUpperCase());

            const partOne = licenseType[0] + random;
            const partTwo = (serialBytes[2] + serialBytes[0] + serialBytes[3] + serialBytes[1]).insert(random, licenseType[1]);
            const partThree = expires[1] + expires[3] + expires[2] + expires[0];

            return `${partOne}-${partTwo}-${checker1}-${partThree}-${checker2}-DF`;
        },

        generateDesktopLicense(serialNumber, quantity = 1) {
            if (!serialNumber || serialNumber.length > 12) {
                console.error('Serial do painel deve ter até 12 caracteres');
                return null;
            }

            const model = "DF0023-PL-1A";
            const licenseType = ["6", "4"];
            const serial = this.getPanelSerial(serialNumber);
            const random = this.getRandom();
            const expires = this.getExpiresDate(quantity, model);
            const checker1 = this.getChecker(serial[2], expires[0]);
            const checker2 = this.getChecker(serial[3], expires[1]);

            const serialBytes = serial.map(part => parseInt(part, 10).toString(16).padStart(2, '0').toUpperCase());

            const partOne = licenseType[0] + random;
            const partTwo = (serialBytes[2] + serialBytes[0] + serialBytes[3] + serialBytes[1]).insert(random, licenseType[1]);
            const partThree = expires[1] + expires[3] + expires[2] + expires[0];

            return `${partOne}-${partTwo}-${checker1}-${partThree}-${checker2}-DF`;
        },

        generateWebLicense(serialNumber, quantity = 1) {
            if (!serialNumber || serialNumber.length > 12) {
                console.error('Serial do painel deve ter até 12 caracteres');
                return null;
            }

            const model = "DF0023-PW-1A";
            const licenseType = ["7", "7"];
            const serial = this.getPanelSerial(serialNumber);
            const random = this.getRandom();
            const expires = this.getExpiresDate(quantity, model);
            const checker1 = this.getChecker(serial[2], expires[0]);
            const checker2 = this.getChecker(serial[3], expires[1]);

            const serialBytes = serial.map(part => parseInt(part, 10).toString(16).padStart(2, '0').toUpperCase());

            const partOne = licenseType[0] + random;
            const partTwo = (serialBytes[2] + serialBytes[0] + serialBytes[3] + serialBytes[1]).insert(random, licenseType[1]);
            const partThree = expires[1] + expires[3] + expires[2] + expires[0];

            return `${partOne}-${partTwo}-${checker1}-${partThree}-${checker2}-DF`;
        },
        // Validador de Licença
        validateLicenseType(license, expectedType) {
            if (!license || typeof license !== 'string') {
                return false;
            }

            const keyElements = this.getKeyElements(license);
            if (!keyElements || keyElements.length !== 3) {
                return false;
            }

            // O primeiro elemento é o tipo da licença
            const licenseType = keyElements[0].toLowerCase();
            return licenseType === expectedType.toLowerCase();
        },

        // Métodos auxiliares
        decryptKey(license) {
            try {
                // Split da licença em elementos
                const licenseElements = license.split('-');
                if (licenseElements.length !== 6) return null;

                // Extração do tipo
                const type1 = licenseElements[0].substring(0, 1);
                const randomPosition = parseInt(licenseElements[0].substring(1, 2));
                const type2 = licenseElements[1].substring(randomPosition, randomPosition + 1).toUpperCase();
                const type = type1 + type2;

                // Mapa de tipos de licença
                const typeMap = {
                    '66': 'f',
                    '64': 'd',
                    '77': 'w',
                    '75': 'u',
                    '6D': 'm',
                    '72': 'r',
                    '74': 't'
                };

                const typeCharacter = typeMap[type];
                if (!typeCharacter) return null;

                // Processamento do número de série
                const serie = licenseElements[1].slice(0, randomPosition) + 
                            licenseElements[1].slice(randomPosition + 1);
                
                const serieElements = [
                    serie.substring(2, 4),
                    serie.substring(6, 8),
                    serie.substring(0, 2),
                    serie.substring(4, 6)
                ];

                let finalSerie = '';
                for (const serieElement of serieElements) {
                    const num = parseInt(serieElement, 16).toString();
                    finalSerie += num.padStart(3, '0');
                }

                // Processamento da data
                const date = licenseElements[3];
                const dateElements = [
                    date.substring(6, 8),
                    date.substring(0, 2),
                    date.substring(4, 6),
                    date.substring(2, 4)
                ];

                let finalDate = '';
                for (const dateElement of dateElements) {
                    const num = parseInt(dateElement, 16).toString().padStart(2, '0');
                    finalDate += num;
                }

                const formattedDate = `${finalDate.substring(0, 2)}-${finalDate.substring(2, 4)}-${finalDate.substring(4)}`;

                // Validação dos checksums
                const xx = parseInt(serieElements[2], 16);
                const dd = parseInt(dateElements[0], 16);
                const check1 = this.adjustChecker(xx + dd);

                const zz = parseInt(serieElements[3], 16);
                const mm = parseInt(dateElements[1], 16);
                const check2 = this.adjustChecker(zz + mm);

                const c1 = check1.toString(16).padStart(2, '0').toUpperCase();
                const c2 = check2.toString(16).padStart(2, '0').toUpperCase();

                if (c1 !== licenseElements[2] || c2 !== licenseElements[4]) {
                    return null;
                }

                // Montagem da chave descriptografada
                return `${typeCharacter}T${finalSerie}T${formattedDate}`;
            }
            catch (error) {
                console.error('Erro ao descriptografar licença:', error);
                return null;
            }
        },

        adjustChecker(val) {
            while (val > 255) {
                val -= 255;
            }
            return val;
        },
        
        getKeyElements(key) {
            if (!key) return null;
            
            const decryptedKey = this.decryptKey(key.trim());
            if (!decryptedKey) return null;
            
            return decryptedKey.split('T');
        },

        getRandom() {
            const random = Math.floor(Math.random() * 8);
            while (random === this.lastRandom) {
                random = Math.floor(Math.random() * 8);
            }
            this.lastRandom = random;
            return random;
        },

        getExpiresDate(quantity = 1, model) {
            // Garantindo que quantity seja número
            const years = parseInt(quantity) || 1;
            let date = new Date();
            
            if (model.includes("D30")) {
                date.setDate(date.getDate() + (30 * years));
            } 
            else if (model === "DF0023-FL") {
                date.setFullYear(date.getFullYear() + 99);
                date.setMonth(date.getMonth() + 6);
                date.setDate(date.getDate() + 15);
            }
            else {
                date.setFullYear(date.getFullYear() + years);
            }

            return [
                this.intToHex(date.getDate()),
                this.intToHex(date.getMonth() + 1),
                this.intToHex(parseInt(date.getFullYear().toString().substring(0, 2))),
                this.intToHex(parseInt(date.getFullYear().toString().substring(2)))  // Corrigido substring
            ];
        },

        getHDDSerial(hdd) {
            return [
                hdd.substring(0, 2),
                hdd.substring(2, 4), 
                hdd.substring(4, 6),
                hdd.substring(6, 8)
            ];
        },

        //getPanelSerial(serial) {
        //    const paddedSerial = serial.padStart(12, '0');
        //    return [
        //        paddedSerial.substring(2, 4),
        //        paddedSerial.substring(4, 6),
        //        paddedSerial.substring(6, 8),
        //        paddedSerial.substring(8, 10)
        //    ];
        //},
        getPanelSerial(serial) {
            const paddedSerial = serial.padStart(12, '0');
            return [
                paddedSerial.substring(0, 3),  
                paddedSerial.substring(3, 6),  
                paddedSerial.substring(6, 9),  
                paddedSerial.substring(9, 12)  
            ];
        },

        getChecker(val1, val2) {
            let v1 = this.hexToInt(val1);
            let v2 = this.hexToInt(val2);
            let v = v1 + v2;

            while (v > 255) {
                v -= 255;
            }

            return this.intToHex(v);
        },

        intToHex(value) {
            return value.toString(16).padStart(2, '0').toUpperCase();
        },

        hexToInt(value) {
            return parseInt(value, 16);
        }
    },

    registerGlobally() {
        if (typeof window !== 'undefined') {
            window.Helper = this;
            console.log('Helper registrado globalmente.');
        }
    }
}

Helper.registerGlobally();
export default Helper;